import { useMutation, useQuery } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { Button, Card, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { setInputFilter } from "../../../utils/helpers/utils";
import QUERY from "../../../utils/service/query";

const Configurations = () => {
	const { data } = useQuery(QUERY.CONFIG.GET_ARCHIVE_CONFIG_VALUE);
	const [updateConfig] = useMutation(QUERY.CONFIG.UPDATE_ARCHIVE_CONFIG_VALUE);
	const res = useQuery(QUERY.CONFIG.GET_DISABLE_CONFIG_VALUE);
	const [updateConfig1] = useMutation(QUERY.CONFIG.UPDATE_DISABLE_CONFIG_VALUE);
	const [archiveCount, setArchiveCount] = useState("");
	const [disableCount, setDisableCount] = useState("");

	return (
		<>
			<Card className="mb-3">
				<Card.Header>
					<h5>Configurations</h5>
				</Card.Header>
				<Card.Body className="bg-light">
					<Form>
						<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
							<Form.Label>
								Auto-Archive Report Count (Current Value=
								<b>{data?.getOneConfig?.configValue}</b>)
							</Form.Label>
							<Form.Control
								type="text"
								required
								placeholder="Count of unique reports to auto-archive a UGC"
								className="form-control-md"
								value={archiveCount}
								onChange={(e) =>
									setInputFilter(e.target.value) &&
									setArchiveCount(e.target.value)
								}
							/>
						</Form.Group>
						<Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
							<Form.Label>
								Auto Disable Warning Count (Current Value=
								<b>{res?.data?.getOneConfig?.configValue}</b>)
							</Form.Label>
							<Form.Control
								type="text"
								required
								placeholder="Count of warnings to auto-disable user account"
								className="form-control-md"
								value={disableCount}
								onChange={(e) => {
									setInputFilter(e.target.value) &&
										setDisableCount(e.target.value);
								}}
							/>
						</Form.Group>
						<Button
							className="mt-2"
							variant="primary"
							type="button"
							// disabled={
							// 	res?.data?.getOneConfig?.configValue == disableCount
							// 		? true
							// 		: false
							// }
							onClick={(e) => {
								e.preventDefault();
								disableCount &&
									updateConfig1({
										refetchQueries: [
											QUERY.CONFIG.GET_DISABLE_CONFIG_VALUE,
											QUERY.CONFIG.GET_ARCHIVE_CONFIG_VALUE,
										],
										variables: {
											configValue: disableCount,
										},
									})
										.then(() => {
											toast.dismiss();
											setDisableCount("");
											toast.success("Configuration updated successfully");
										})
										.catch(() => {
											toast.dismiss();
											toast.error("Something went wrong!");
										});

								archiveCount &&
									updateConfig({
										refetchQueries: [
											QUERY.CONFIG.GET_ARCHIVE_CONFIG_VALUE,
											QUERY.CONFIG.GET_DISABLE_CONFIG_VALUE,
										],
										variables: {
											configValue: archiveCount,
										},
									})
										.then(() => {
											toast.dismiss();
											setArchiveCount("");
											toast.success("Configuration updated successfully");
										})
										.catch(() => {
											toast.dismiss();
											toast.error("Something went wrong!");
										});
							}}>
							Submit
						</Button>
					</Form>
				</Card.Body>
			</Card>
		</>
	);
};

export default Configurations;
